import request from '@/utils/request'

// ==================== 优惠券模板管理 ====================

/**
 * 创建优惠券模板
 * @param {Object} data - 模板数据
 * @returns {Promise}
 */
export function createCouponTemplate(data) {
  return request({
    url: '/coupon/templates',
    method: 'post',
    data
  })
}

/**
 * 获取优惠券模板列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getCouponTemplates(params) {
  return request({
    url: '/coupon/templates',
    method: 'get',
    params
  })
}

/**
 * 更新优惠券模板
 * @param {number} templateId - 模板ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateCouponTemplate(templateId, data) {
  return request({
    url: `/coupon/templates/${templateId}`,
    method: 'put',
    data
  })
}

/**
 * 获取优惠券模板详情
 * @param {number} templateId - 模板ID
 * @returns {Promise}
 */
export function getCouponTemplate(templateId) {
  return request({
    url: `/coupon/templates/${templateId}`,
    method: 'get'
  })
}

// ==================== 优惠券发放管理 ====================

/**
 * 发放优惠券
 * @param {Object} data - 发放数据
 * @returns {Promise}
 */
export function issueCoupon(data) {
  return request({
    url: '/coupon/issue',
    method: 'post',
    data
  })
}

/**
 * 批量发放优惠券
 * @param {Object} data - 批量发放数据
 * @returns {Promise}
 */
export function batchIssueCoupon(data) {
  return request({
    url: '/coupon/batch-issue',
    method: 'post',
    data
  })
}

// ==================== 用户优惠券管理 ====================

/**
 * 获取用户优惠券列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getMyCoupons(params) {
  return request({
    url: '/coupon/my-coupons',
    method: 'get',
    params
  })
}

/**
 * 获取用户优惠券详情
 * @param {number} couponId - 优惠券ID
 * @returns {Promise}
 */
export function getMyCouponDetail(couponId) {
  return request({
    url: `/coupon/my-coupons/${couponId}`,
    method: 'get'
  })
}

/**
 * 获取用户优惠券使用记录
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getMyUsageRecords(params) {
  return request({
    url: '/coupon/my-usage-records',
    method: 'get',
    params
  })
}

// ==================== 优惠券核销管理 ====================

/**
 * 验证优惠券（不实际核销）
 * @param {Object} data - 验证数据
 * @returns {Promise}
 */
export function validateCoupon(data) {
  return request({
    url: '/coupon/validate',
    method: 'post',
    data
  })
}

/**
 * 二维码核销优惠券
 * @param {Object} data - 核销数据
 * @returns {Promise}
 */
export function verifyCoupon(data) {
  return request({
    url: '/coupon/verify',
    method: 'post',
    data
  })
}

// ==================== 辅助功能 ====================

/**
 * 获取优惠券来源类型选项
 * @returns {Array}
 */
export function getSourceTypeOptions() {
  return [
    { value: 1, label: '推荐奖励' },
    { value: 2, label: '系统发放' },
    { value: 3, label: '活动获得' }
  ]
}

/**
 * 获取优惠券状态选项
 * @returns {Array}
 */
export function getCouponStatusOptions() {
  return [
    { value: 0, label: '未使用', type: 'success' },
    { value: 1, label: '已使用', type: 'info' },
    { value: 2, label: '已过期', type: 'danger' }
  ]
}

/**
 * 格式化折扣率显示
 * @param {number} discountRate - 折扣率（0.6表示6折）
 * @returns {string}
 */
export function formatDiscountRate(discountRate) {
  return `${(discountRate * 10).toFixed(1)}折`
}

/**
 * 计算优惠金额
 * @param {number} originalAmount - 原价金额
 * @param {number} discountRate - 折扣率
 * @returns {Object}
 */
export function calculateDiscount(originalAmount, discountRate) {
  const discountAmount = originalAmount * (1 - discountRate)
  const finalAmount = originalAmount - discountAmount
  
  return {
    originalAmount: parseFloat(originalAmount.toFixed(2)),
    discountAmount: parseFloat(discountAmount.toFixed(2)),
    finalAmount: parseFloat(finalAmount.toFixed(2))
  }
} 